import React, { useState, useEffect, useContext } from "react";
import { Box, Container, makeStyles, TableBody, TableHead, TablePagination, Avatar, Grid, Tooltip } from "@material-ui/core";
import { productsServices } from "../services";
import IconButton from "@material-ui/core/IconButton";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CheckCircle from "@material-ui/icons/CheckCircle";
import { AuthContext } from "../context";
import { Toast, ConfirmationModal, SimpleToolbar, Loader, Drawer, StyledTableCell, StyledTableRow, BaseTable } from "../components";
import { useDrawer } from "../hooks";

export default function ProductsListApproval(props) {
	const classes = useStyles();
	const [products, setProducts] = useState([]);
	const { authState, signOut } = useContext(AuthContext);
	const [loading, setLoading] = useState(false);
	const [limit, setLimit] = useState(100);
	const [page, setPage] = useState(1);
	const [count, setCount] = useState(0);
	const [toast, setToast] = useState(false);
	const [toastMessage, setToastMessage] = useState("");
	const [openAlert, setOpenAlert] = useState(false);
	const [productId, setProductId] = useState(null);
	const [status, setStatus] = useState(null);
	const [reload, setReload] = useState(false);
	const { isOpen, setIsOpen } = useDrawer();

	useEffect(() => {
		getProductsPendingApproval();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [page, limit, authState, reload]);

	const getProductsPendingApproval = async (text='') => {
		try {
			setLoading(true);
			const { status, response } = await productsServices.getProductsPendingApprovalFilter({ text, page, limit, token: authState.token });
			setLoading(false);
			if (status === 200) {
				setProducts(response.products);
				setLimit(response.limit);
				setCount(response.total);
				setPage(response.page);
			} else if (status === 401) {
				signOut();
			}
		} catch (e) {
			setLoading(false);
			console.log(e);
		}
	};

	const updateStatus = async () => {
		try {
			setLoading(true);
			const { status: statusResp, response } = await productsServices.updateProductStatus({ status, token: authState.token, productId });
			setLoading(false);
			if (statusResp === 200) {
				setReload(true);
				setToastMessage("Producto actualizado");
				setToast(true);
			} else if (status === 401) {
				signOut();
			}
			if (response.error) {
				setToastMessage(response.error.message, true);
				setToast(true);
			}
		} catch (e) {
			setLoading(false);
			console.log(e);
		}
	};

	const confirmationModal = (_id, status) => {
		setOpenAlert(true);
		setProductId(_id);
		setStatus(status);
	};

	return (
		<>
			<Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
			<Grid container className={classes.container} style={{ flex: 1 }}>
				{loading && <Loader loading={true} />}
				<Grid item sm={12} xs={12}>
					<div className={classes.root}>
						<Toast
							message={toastMessage}
							open={toast}
							close={() => {
								setToast(false);
							}}
						/>
						<ConfirmationModal open={openAlert} setOpenAlert={setOpenAlert} setConfirmAction={() => updateStatus()} />
						<Container maxWidth={false}>
							<SimpleToolbar
								onFilter={(text) => getProductsPendingApproval(text)}
								table={"productsApprovalTable"}
								filename={"Productos por aprobar"}
								isOpen={isOpen}
								setIsOpen={(value) => setIsOpen(value)}
							/>
							<BaseTable tableId="productsApprovalTable">
								<TableHead>
									<StyledTableRow>
										<StyledTableCell>Producto</StyledTableCell>
										<StyledTableCell>Registro</StyledTableCell>
										<StyledTableCell>Laboratorio</StyledTableCell>
										<StyledTableCell>Molécula</StyledTableCell>
										<StyledTableCell>Indicaciones</StyledTableCell>
										<StyledTableCell>Presentaciones</StyledTableCell>
										<StyledTableCell>Concentración</StyledTableCell>
										<StyledTableCell>Registro</StyledTableCell>
										<StyledTableCell>Estado</StyledTableCell>
										<StyledTableCell>Opciones</StyledTableCell>
									</StyledTableRow>
								</TableHead>
								<TableBody>
									{products.map((product, index) => (
										<StyledTableRow hover key={product._id}>
											<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>
												<Box alignItems="center" display="flex">
													<Avatar className={classes.avatar} src={product.logo} />
													{product.name}
												</Box>
											</StyledTableCell>
											<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>{product.isp}</StyledTableCell>
											<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>
												{product.laboratory.name}
											</StyledTableCell>
											<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>{product.molecule}</StyledTableCell>
											<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>{product.indications}</StyledTableCell>
											<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>{product.presentation}</StyledTableCell>
											<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>{product.concentration}</StyledTableCell>
											<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>{product.isp}</StyledTableCell>
											<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>
												{product.status === 0 ? "Pendiente" : product.status === 1 ? "Aprobado" : "Rechazado"}
											</StyledTableCell>
											<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>
												<IconButton onClick={() => confirmationModal(product._id, 1)}>
													<Tooltip title="Aprobar" aria-label="active">
														<CheckCircle />
													</Tooltip>
												</IconButton>
												<IconButton onClick={() => confirmationModal(product._id, 2)}>
													<Tooltip title="Rechazar" aria-label="active">
														<HighlightOffIcon />
													</Tooltip>
												</IconButton>
											</StyledTableCell>
										</StyledTableRow>
									))}
								</TableBody>
							</BaseTable>
							<TablePagination
								labelRowsPerPage="Registros por página"
								component="div"
								count={count}
								onChangeRowsPerPage={(e) => {
									setLimit(parseInt(e.target.value));
								}}
								onChangePage={(e, page) => {
									setPage(page + 1);
								}}
								page={page - 1}
								rowsPerPage={limit}
								rowsPerPageOptions={[10, 25, 50, 100]}
								classes={{ root: classes.pagination }}
							/>
						</Container>
					</div>
				</Grid>
			</Grid>
		</>
	);
}

const useStyles = makeStyles((theme) => ({
	root: {
		paddingBottom: theme.spacing(2),
		paddingTop: theme.spacing(2),
	},
	avatar: {
		marginRight: theme.spacing(2),
	},
	pagination: {
		color: theme.palette.secondary.main,
		[theme.breakpoints.down("xs")]: {
			position: "absolute",
			bottom: 0,
		},
	},
}));
